import { css } from 'styled-components';
import { CALYPSO } from '../constants/WidgetColors';
export const focusRing = css(["outline-offset:1px;outline:2px solid ", ";"], CALYPSO);